import React from 'react';
import Helmet from 'react-helmet';
import { withStyles } from '@material-ui/core/styles';
import { DragDropContext } from 'react-dnd';
import MultiBackend from 'react-dnd-multi-backend';
import Preview from 'react-dnd-preview';
import HTML5toTouch from 'react-dnd-multi-backend/lib/HTML5toTouch';
import styles from './app.styles';
import Routes from './routes';
import { GTMID, ENVIRONMENT } from '../configurations';
import Footer from '../shared/footer/footer';
import { compose, isMobileOrTablet } from '../utility';
import { ENVIRONMENTS } from '../constants';
import { generateToolbarPreviews } from '../editor/core/toolbar/dragPreview';

type PropType = {
  gtmId: string,
};

const GoogleTagManager = ({ gtmId }: PropType) => (
  <noscript>
    <iframe
      title="google-tag-manager"
      src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
      height="0"
      width="0"
      style={{ display: 'none', visibility: 'hidden' }}
    />
  </noscript>
);

const App = () => (
  <React.Fragment>
    <Helmet>
      <script type="text/javascript">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${GTMID}');
        `}
      </script>
      <meta charSet="utf-8" />
      <meta name="description" content="RealDesk Esign" />
      <title>RealDesk Esign </title>
    </Helmet>
    <GoogleTagManager gtmId={GTMID} />
    <Routes />
    {
      // Mobile DnD backend doesn't support preview, so using custom Preview component
      isMobileOrTablet() && <Preview generator={generateToolbarPreviews} />
    }
    {ENVIRONMENT !== ENVIRONMENTS.PROD &&
      ENVIRONMENT !== ENVIRONMENTS.DEV &&
      ENVIRONMENT !== ENVIRONMENTS.CI && <Footer />}
  </React.Fragment>
);

export default compose(
  withStyles(styles, { withTheme: true }),
  DragDropContext(MultiBackend(HTML5toTouch))
)(App);
